import { NavLink } from "react-router";
import number_format from "../../utils/number_format";
import { PartnerApi } from "../../api/partner.api";
import { useTranslation } from "../../hooks/useTranslation";

export default function DealRow({
                                       awailableColumns,
                                       selectedColumns,
                                       deal,
                                   }) {
    const { t } = useTranslation();
    return (
        <tr>
            {Object.keys(awailableColumns)
                .filter((awailableColumnsKey) =>
                    selectedColumns.includes(awailableColumnsKey)
                )
                .map((awailableColumnsKey) => (
                    <td
                        key={awailableColumnsKey}
                        className={
                            ["total_amount_currency"].includes(
                                awailableColumnsKey
                            ) && "text-end"
                        }
                    >
                        {[
                                "specification",
                            ].includes(awailableColumnsKey) && (
                            deal[awailableColumnsKey].length > 30 ? (
                                (deal[awailableColumnsKey].substring(0, 30)+"...")
                            ) : (
                                deal[awailableColumnsKey]
                            )
                        )}

                        {[
                                "deal_number",
                                "description",
                                "issued_by",
                                "opportunity_id",
                                "project_name",
                            ].includes(awailableColumnsKey) &&
                            deal[awailableColumnsKey]}

                        {"deal_id" == awailableColumnsKey && (
                            <>
                                <NavLink to={"/deal/" + deal.deal_id}>
                                    {deal.deal_id}
                                </NavLink>
                            </>
                        )}
                        {[
                                "realization_date",
                                "close_date",
                                "registration_date",
                                "expiration_date",
                            ].includes(awailableColumnsKey) &&
                            (deal[awailableColumnsKey] &&
                            deal[awailableColumnsKey] != "0000-00-00"
                                ? new Date(
                                    deal[awailableColumnsKey]
                                ).toLocaleDateString()
                                : "-")}

                        {"deal_state" == awailableColumnsKey && (
                            <span
                                className={
                                    "badge badge-" + deal.deal_state.state_style
                                }
                            >
                                  {deal.deal_state.state_name}
                                </span>
                        )}

                        {"vendor" == awailableColumnsKey && (
                            <>{deal.vendor.name}</>
                        )}

                        {"sales_person" == awailableColumnsKey && (
                            <>
                                {deal.sales_person?.first_name}
                                &nbsp;
                                {deal.sales_person?.last_name}
                            </>
                        )}

                        {"end_customer" == awailableColumnsKey && (
                            <>
                                {deal.end_customer.name}
                                {deal.end_customer.person && (
                                    <>
                                        <br/>
                                        {deal.end_customer.person.first_name}
                                        &nbsp;
                                        {deal.end_customer.person.last_name}
                                    </>
                                )}
                            </>
                        )}
                    </td>
                ))}

            <td className="text-end">
                <NavLink
                    to={"/deal/" + deal.deal_id}
                    className="btn btn-primary"
                >
                    {t("common.detail")}
                </NavLink>
            </td>
        </tr>
    );
}
